const wrapper = "_35swgdo9qx";

export { wrapper };
import "./container.input.style.linaria.module.css";
//# sourceMappingURL=container.input.style.js.map
